import {
  FAQS,
  TERMS_AND_CONDITION,
  PASS_PURCHASE_SUCCESS_MESSAGE,
} from "./helper";
import { routes } from "src/shared/routes";
import { constants } from "src/shared/constants";

import type { TTeamConfig } from "src/shared/types/teamConfig.types";

const LogoImage =
  "https://ss-leagues.s3.amazonaws.com/Minor%20League%20Baseball/rome-emperors-logo.png";
const OrderSummaryBackgroundImage =
  "https://ss-leagues.s3.amazonaws.com/Minor%20League%20Baseball/DBH%20Pass%20Assets/Rome%20Emperors/Background_Image_1.png";

export const romeemperors_pass: TTeamConfig = {
  TEAM_SCHEMA: "romeemperors_pass",
  TEAM_FULL_NAME: "Rome Emperors",
  BROWSER_TITLE: "Emperors Summer Pass",
  CLIENT_ID: "2e75213b8e07.seasonshare.romeemperors-dbh.us",
  VENDOR: constants.vendorUUIDs.ticketmaster,

  TEAM_GLOBAL_SETTINGS: {
    COLORS_PRIMARY: "#010101",
    COLORS_SECONDARY: "#DA291C",
    LOGOUT_ON_INVALID_SESSION: false,
    DEFAULT_APP_ROUTE: routes.landing,
    ACCOUNT_MANAGER_URL: "https://am.ticketmaster.com/romeemperors/",
    NAV_MENU: {
      HIDE_EARN_REWARDS: true,
    },
  },

  LANDING_PAGE_SETTINGS: {
    PASS_BANNER: {
      PASS_DISPLAY_MODE: "separate",
      IS_FLUID_BACKGROUND_IMAGE_SIZE: true,
      DISABLE_BACKGROUND_IMAGE_FILTER: true,
    },

    PASS: {
      HIDE_DECIMAL_POINTS_AFTER_PRICE: true,
    },

    SHOW_ALL_EVENTS_UNDER_PASS: true,
  },

  HOME_PAGE_SETTINGS: {
    EVENT_CARD: {
      ATTEND_BUTTON_COLOR: "#DA291C",
      SHOW_SINGLE_GAMES_IN_COLLAPSE: true,
    },
  },

  GROUP_INVITE_PAGE_SETTINGS: {
    PASS_BANNER: {
      DISABLE_BACKGROUND_IMAGE_FILTER: true,
      PASS_DISPLAY_MODE: "separate",
    },
  },

  CHECKOUT_PAGE_SETTINGS: {
    CHECKOUT_FORM: {
      SAVE_CARD_SWITCH_ENABLED: false,
    },
  },

  MANAGE_SUBSCRIPTION_PAGE_SETTINGS: {
    ZERO_STATE: {
      OPT_OUT_EARLIEST_DATE: new Date("10/01/2024"),
    },
  },

  IMAGES: {
    LOGO_URL: LogoImage + "?width=50&height=50",
    ORDER_SUMMERY_BACKGROUND_URL: OrderSummaryBackgroundImage,
    GROUP_INVITE_PAGE_STATIC_BANNER_URL: OrderSummaryBackgroundImage,
  },

  LANGUAGES: {
    FAQS,
    TERMS_AND_CONDITION,
    PASS_PURCHASE_SUCCESS_MESSAGE,
  },
};
